var _rect, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBg({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1080,
    height: 900,
    viewBox: "0 0 1080 900",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_1385)"
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 900,
    fill: "#3082F7"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M142.863 1215.01C160.744 1181.23 192.163 1156.81 224.308 1136.09C256.454 1115.38 290.548 1097.01 318.219 1070.63C363.426 1027.56 388.158 963.741 383.377 901.424C378.597 839.107 344.269 779.581 292.499 744.515C259.776 722.397 220.45 709.392 192.384 681.54C163.566 652.926 150.472 612.486 128.672 578.229C76.9244 496.877 -27.1262 454.754 -122.142 470.499C-217.157 486.244 -299.644 555.888 -337.826 644.275C-376.008 732.663 -371.413 837.014 -332.379 925.162C-293.345 1013.31 -221.692 1085.26 -137.093 1131.55C-95.6546 1154.3 -51.1165 1171.23 -10.7627 1195.83C29.5912 1220.43 66.7225 1254.52 82.1195 1299.21L149.095 1322.75C123.819 1293.97 124.959 1248.8 142.863 1215.01Z",
    fill: "url(#paint0_linear_1_1385)",
    style: {
      mixBlendMode: "multiply"
    }
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.15
  }, /*#__PURE__*/React.createElement("path", {
    d: "M85.8299 1036.72C95.5695 1016.85 113.307 1002.14 131.532 989.573C149.756 977.003 169.149 965.753 184.684 949.991C210.064 924.248 223.231 886.88 219.354 850.923C215.477 814.966 194.558 781.165 163.987 761.832C144.664 749.639 121.685 742.838 104.954 727.243C87.7735 711.221 79.4781 688.071 66.2572 668.656C34.8728 622.55 -26.0648 600.094 -80.7434 610.944C-135.422 621.793 -181.892 663.589 -202.4 715.413C-222.908 767.237 -218.388 827.51 -194.237 877.78C-170.085 928.049 -127.355 968.349 -77.5945 993.576C-53.2192 1005.97 -27.1549 1014.95 -3.37404 1028.44C20.4068 1041.93 42.493 1060.96 52.1967 1086.53L91.3575 1098.92C76.2231 1082.74 76.0767 1056.58 85.8299 1036.72Z",
    fill: "url(#paint1_linear_1_1385)",
    style: {
      mixBlendMode: "multiply"
    }
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1_1385",
    x1: -397882,
    y1: 103798,
    x2: -101358,
    y2: 423485,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.32
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3082F6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1_1385",
    x1: -228313,
    y1: 67670.6,
    x2: -51089,
    y2: 247142,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3082F6"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_1385"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 1080,
    height: 900,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBg);
export default __webpack_public_path__ + "static/media/BG.697c5c160ae27894166bdfe2604eb6bb.svg";
export { ForwardRef as ReactComponent };